const generateCustomerToken = `
    mutation GenerateCustomerToken($email: String!, $password: String!, $vip_status: Boolean) {
        generateCustomerToken(email: $email, password: $password, vip_status: $vip_status) {
            token
        }
    }
`;

const revokeCustomerToken = `
    mutation {
        revokeCustomerToken {
              result
        }
    }
`;

const createCustomer = `
    mutation CreateCustomerV2($input: CustomerCreateInput!) {
        createCustomerV2(input: $input) {
            customer {
                firstname
                lastname
                email
            }
            token
        }
    }
`;

const requestPasswordResetEmail = `
    mutation RequestPasswordResetEmail($email: String!) {
        requestPasswordResetEmail(email: $email)
    }
`;

const resetPassword = `
    mutation ResetPassword($email: String!, $resetPasswordToken: String!, $newPassword: String!) {
        resetPassword(email: $email, resetPasswordToken: $resetPasswordToken, newPassword: $newPassword)
    }
`;

const changeCustomerPassword = `
    mutation ChangeCustomerPassword($currentPassword: String!, $newPassword: String!) {
        changeCustomerPassword(currentPassword: $currentPassword, newPassword: $newPassword) {
            email
        }
    }
`;

const updateCustomerEmail = `
    mutation UpdateCustomerEmail($email: String! $password: String!) {
        updateCustomerEmail(email: $email, password: $password) {
            customer {
                email
            }
        }
    }
`;

const updateCustomer = `
    mutation UpdateCustomer($input: CustomerUpdateInput!) {
        updateCustomerV2(input: $input) {
            customer {
                firstname
                lastname
                middlename
                taxvat 
            }
        }
    }
`;

export default {
    generateCustomerToken,
    revokeCustomerToken,
    createCustomer,
    requestPasswordResetEmail,
    resetPassword,
    changeCustomerPassword,
    updateCustomerEmail,
    updateCustomer,
};
